import { render, staticRenderFns } from "./PrestigeTagCampaign.vue?vue&type=template&id=21c87bb1"
import script from "./PrestigeTagCampaign.vue?vue&type=script&lang=js"
export * from "./PrestigeTagCampaign.vue?vue&type=script&lang=js"
import style0 from "./PrestigeTagCampaign.vue?vue&type=style&index=0&id=21c87bb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports